import { useState } from 'react';
import { createContainer } from 'unstated-next';
import { LOCAL_STORAGE_TYPES } from '../constants';
import useLocalStorage from '../hooks/localstorage';

const defaultInitialState = {
  accessToken: null,
  onboardingProgress: 35,
};

export function useAuthHook(initialProps = {}) {
  const { remove } = useLocalStorage();

  const [state, setState] = useState({
    ...defaultInitialState,
    ...initialProps,
  });

  const updateAccessToken = accessToken => {
    setState(prev => ({
      ...prev,
      accessToken,
    }));
  };

  const resetAuthState = () => {
    remove(LOCAL_STORAGE_TYPES.WORKSPACE);
    remove(LOCAL_STORAGE_TYPES.USERID);
    remove(LOCAL_STORAGE_TYPES.ADDON);
    setState(defaultInitialState);
  };

  const setOnboardingProgress = onboardingProgress => {
    setState(prev => ({
      ...prev,
      onboardingProgress,
    }));
  };

  return {
    state,
    updateAccessToken,
    resetAuthState,
    setOnboardingProgress,
  };
}

const AuthContainer = createContainer(useAuthHook);

export default AuthContainer;
